module.exports = __webpack_public_path__ + "img/RLP.cf431107.png";